import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  getCurrency,
  setCurrency
} from "../../../../../redux/actions/currencySelect";

const CurrencySelect = props => {
  const { currencySelect } = props;
  const { index, getCurrency, setCurrency } = props;
  const [currencyValue, setCurrencyValue] = useState(
    localStorage.getItem("currency")
  );
  useEffect(() => {
    if (
      localStorage.getItem("currency") !== "HNL" &&
      currencySelect.current === ""
    ) {
      getCurrency();
    }
  }, [getCurrency, currencySelect]);

  //Cristian: Se utiliza solo para que muestre todos los productos en dólares siempre
  /* useEffect(() => {
    setCurrency("USD");
  }, [setCurrency]); */

  const handleChange = async event => {
    if (event.target.value === "HNL") {
      setCurrencyValue("HNL");
      setCurrency("HNL");
    } else {
      setCurrencyValue("USD");
      setCurrency("USD");
    }
  };
  return (
    <select
      //hidden
      className={`select-cash ${
        index ? "select-cash-white" : "select-cash-black"
      }`}
      onChange={event => handleChange(event)}
      defaultValue={currencyValue}
    >
      <option value="HNL" className="option-bgblack">
        HNL
      </option>
      <option value="USD" className="option-bgblack">
        USD
      </option>
    </select>
  );
};

const mapStateToProps = state => {
  return {
    currencySelect: state.currencySelect
  };
};

export default connect(mapStateToProps, { getCurrency, setCurrency })(
  CurrencySelect
);
